import { cr, URLS } from "fire-wind-water";
import { $cmsData, settings } from "../common/setting";

const paginationArt = require("../../art/common/paginationNumber.art");
class Pagination {
  $skelem = ".pagination";
  total: number;
  current: number;
  showCount: number;
  pageUrl: string;
  isPreview: boolean = settings.isPreview;

  skAfterViewChecked(): void {
    if (this.isPreview) {
      cr.each($cmsData.container, (item: { [label: string]: any }) => {
        cr.each(item, (d) => {
          if (
            (d.type === "MIMAGETEXT" ||
              d.type === "MEETING" ||
              d.type === "VIDEO" ||
              d.type === "FILE") &&
            d.isMain == 1
          ) {
            this.total = settings.total || d.historyContent.content.total;
            this.current = settings.current || URLS.getURL("current") || 1;
            this.showCount =
              settings.showCount || d.historyContent.content.showCount;
            this.pageUrl = settings.pageUrl || d.historyContent.content.pageUrl;
          }
        });
      });
    } else {
      this.total = settings.total;
      this.current = settings.current;
      this.showCount = settings.showCount;
      this.pageUrl = settings.pageUrl;
    }
    this.initPaginationDom();
  }
  initPaginationDom(): void {
    const PaginationArr = document.querySelectorAll(".pagination");
    cr.each(PaginationArr, (dom) => {
      const total: number = Number(this.total) || 0;
      const current = Number(this.current);
      const pageSize = Number(this.showCount);
      const pageNum = Math.ceil(total / pageSize);
      // const pageIndexList = [...Array(pageNum).keys()]
      const pageIndexList = new Array(pageNum);
      for (let i = 0; i < pageIndexList.length; i++) {
        pageIndexList[i] = i + 1;
      }
      let pageIndexListCurrent = [];
      if (current < 4) {
        pageIndexListCurrent = pageIndexList.slice(0, 5);
      } else if (current >= 4 && current < pageNum - 2) {
        pageIndexListCurrent = pageIndexList.slice(current - 3, current + 2);
      } else {
        pageIndexListCurrent = pageIndexList.slice(-5);
      }
      const params = {
        current: current,
        pageIndexListCurrent: pageIndexListCurrent,
        pageNum: pageNum,
        isPreview: this.isPreview,
      };
      dom.innerHTML = total > 0 ? paginationArt(params) : "";
    });
    this.skUpdateView();
  }
  tipsShow(e): void {
    const index = e.target.dataset.index;
    if (index == this.current) {
      return;
    }
    if (this.isPreview && URLS.getURL("preview")) {
      $sk.alert("预览页面不支持跳转");
    } else {
      // const href = this.pageUrl.substring(0, this.pageUrl.length - 5);
      // const hrefArr = href.split("_");
      // if (index == 1) {
      //   window.location.href = `${hrefArr[0]}_${hrefArr[1]}.html${window.location.search}`;
      // } else {
      //   window.location.href = `${hrefArr[0]}_${hrefArr[1]}_${index}.html${window.location.search}`;
      // }

      // 解析URL参数
      const params: URLSearchParams = new URLSearchParams(
        window.location.search
      );
      // 获取特定参数的值
      const oldValue = params.get("start");
      // 修改参数值
      const newStart = (index - 1) * this.showCount;
      params.set("start", newStart.toString());
      params.set("current", index);
      // 构建新的URL
      const newUrl =
        window.location.origin +
        window.location.pathname +
        "?" +
        params.toString();
      // 替换URL
      window.location.replace(newUrl);
    }
  }
  nothing(): void {
    console.log("nothing");
  }
  skUpdateView(): void {}
}
export { Pagination };
